import { useTranslation } from 'react-i18next';
import { AddGuestBody } from '@components/modals/add-holder-modal/add-holder-modal.type';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type { AddGuestResponse } from './use-add-guest.type';

const addGuest = async ({ formValue }: { formValue: AddGuestBody }) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/add-guest`;

  return request({ url, method: RequestMethod.POST, body: formValue });
};

export const useAddGuest = ({ hideToast }: { hideToast?: boolean } = {}) => {
  const toast = useToast();
  const { t } = useTranslation();
  return useGenericMutation<AddGuestResponse, RequestError, { formValue: AddGuestBody }>(
    [QUERY_KEYS.addGuest],
    async ({ formValue }: { formValue: AddGuestBody }) => addGuest({ formValue }),
    {
      onSuccess: hideToast
        ? () => {}
        : () => {
            toast.push({
              title: t('passes:addHolderSuccessNotificationTitle'),
              text: '',
              type: 'success',
            });
          },
      // TODO: Show only custom error on demand https://xceeddev.atlassian.net/browse/XCEED-5272
      // onError: () => {
      //   toast.push({
      //     title: t('passes:addHolderErrorNotificationTitle'),
      //     text: '',
      //     type: 'error',
      //     disableTimeOut: true,
      //   });
      // },
    }
  );
};
